<script>
  import * as d3 from "d3";
  import { onMount } from "svelte";
  import {
    averageAge,
    averageCommute,
    averageDeprivation,
    averageWalk,
    totalPopulation,
    totalJobs,
    InsightsRadioCheck,
  } from "../../store.js";
  let speedValue;

  onMount(() => {
    averageAge.subscribe((value) => {
      document
        .querySelectorAll(".triangle")
        .forEach((element) => element.remove());
      if ($totalPopulation != 0) {
        gaugeViz("#speedometer", "#percent", (value / $totalPopulation) * 100);
      }
    });
    averageCommute.subscribe((value) => {
      document
        .querySelectorAll(".triangle")
        .forEach((element) => element.remove());

      if ($totalPopulation != 0) {
        gaugeViz(
          "#speedometer1",
          "#percent1",
          (value / $totalPopulation) * 100
        );
      }
    });
    averageWalk.subscribe((value) => {
      document
        .querySelectorAll(".triangle")
        .forEach((element) => element.remove());

      if ($totalPopulation != 0) {
        gaugeViz(
          "#speedometer2",
          "#percent2",
          (value / $totalPopulation) * 100
        );
      }
    });
    averageDeprivation.subscribe((value) => {
      document
        .querySelectorAll(".triangle")
        .forEach((element) => element.remove());

      gaugeVizDep("#speedometer3", "#percent3", value * 100);
    });
  });

  function gaugeViz(layer, percent, value) {
    var chart = d3.select(layer);

    const arc = d3
      .arc()
      .outerRadius(120)
      .innerRadius(90)
      .startAngle(-Math.PI / 1.3);

    chart
      .append("path")
      .datum({
        endAngle: Math.PI / 1.3,
      })
      .attr("transform", "translate(160, 180)")
      .attr("class", "background")
      .style("fill", "white")
      .attr("d", arc);

    const triangle = chart
      .append("g")
      .datum({ endAngle: -Math.PI / 1.3 })
      .style("width", "100%")
      .append("path")
      .attr("d", "M3.937,0,7.873,14H0Z");

    const newAngle = 2.427 * ((value - 50) / 50);
    let foreground;
    if ($InsightsRadioCheck == "SP") {
      foreground = chart
        .append("path")
        .datum({ endAngle: -Math.PI / 1.3 })
        .style("fill", "#45bcbb")
        .attr("transform", "translate(160, 180)")
        .attr("d", arc);
    }
    if ($InsightsRadioCheck == "OZP") {
      foreground = chart
        .append("path")
        .datum({ endAngle: -Math.PI / 1.3 })
        .style("fill", "#0a6a5b")
        .attr("transform", "translate(160, 180)")
        .attr("d", arc);
    }
    if ($InsightsRadioCheck == "LP") {
      foreground = chart
        .append("path")
        .datum({ endAngle: -Math.PI / 1.3 })
        .style("fill", "#D9484D")
        .attr("transform", "translate(160, 180)")
        .attr("d", arc);
    }

    foreground
      .transition()
      .duration(3000)
      .attrTween("d", function (d) {
        const interpolate = d3.interpolate(d.endAngle, newAngle);
        return function (t) {
          d.endAngle = interpolate(t);
          speedValue = Math.round(0.5 * (d.endAngle / 2.427) * 100) + 50;

          document.querySelector(percent).textContent = speedValue + "%";
          return arc(d);
        };
      });

    triangle
      .transition()
      .duration(3000)
      .attr("fill", "white")
      .attr("class", "triangle")
      .attrTween("transform", function (d) {
        const interpolate = d3.interpolate(d.endAngle, newAngle);
        return function (t) {
          const angleRadians = interpolate(t);
          const angleDegrees = (360 * angleRadians) / (2 * Math.PI);
          return `
        translate(158 176)
        rotate(${angleDegrees + 180} 3.5 7)
        translate(0 132)
      `;
        };
      });

    function pathTween(path) {
      const length = path.node().getTotalLength(); // Get the length of the path
      const r = d3.interpolate(0, length); // Set up interpolation from 0 to the path length
      return function (t) {
        const point = path.node().getPointAtLength(r(t)); // Get the next point along the path
        d3.select(this) // Select the circle
          .attr("transform", `translate(${point.x}, ${point.y})`);
      };
    }
  }
  function gaugeVizDep(layer, percent, value) {
    var chart = d3.select(layer);

    const arc = d3
      .arc()
      .outerRadius(120)
      .innerRadius(90)
      .startAngle(-Math.PI / 1.3);

    chart
      .append("path")
      .datum({
        endAngle: Math.PI / 1.3,
      })
      .attr("transform", "translate(160, 180)")
      .attr("class", "background")
      .style("fill", "white")
      .attr("d", arc);

    const triangle = chart
      .append("g")
      .datum({ endAngle: -Math.PI / 1.3 })
      .style("width", "100%")
      .append("path")
      .attr("d", "M3.937,0,7.873,14H0Z");

    const newAngle = 2.427 * ((value - 50) / 50);

    let foreground;
    if ($InsightsRadioCheck == "SP") {
      foreground = chart
        .append("path")
        .datum({ endAngle: -Math.PI / 1.3 })
        .style("fill", "#45bcbb")
        .attr("transform", "translate(160, 180)")
        .attr("d", arc);
    }
    if ($InsightsRadioCheck == "OZP") {
      foreground = chart
        .append("path")
        .datum({ endAngle: -Math.PI / 1.3 })
        .style("fill", "#0a6a5b")
        .attr("transform", "translate(160, 180)")
        .attr("d", arc);
    }
    if ($InsightsRadioCheck == "LP") {
      foreground = chart
        .append("path")
        .datum({ endAngle: -Math.PI / 1.3 })
        .style("fill", "#D9484D")
        .attr("transform", "translate(160, 180)")
        .attr("d", arc);
    }

    foreground
      .transition()
      .duration(3000)
      .attrTween("d", function (d) {
        const interpolate = d3.interpolate(d.endAngle, newAngle);
        return function (t) {
          d.endAngle = interpolate(t);
          speedValue = Math.round(0.5 * (d.endAngle / 2.427) * 100) + 50;

          document.querySelector(percent).textContent = speedValue + "%";
          return arc(d);
        };
      });

    triangle
      .transition()
      .duration(3000)
      .attr("fill", "white")
      .attr("class", "triangle")
      .attrTween("transform", function (d) {
        const interpolate = d3.interpolate(d.endAngle, newAngle);
        return function (t) {
          const angleRadians = interpolate(t);
          const angleDegrees = (360 * angleRadians) / (2 * Math.PI);
          return `
        translate(158 176)
        rotate(${angleDegrees + 180} 3.5 7)
        translate(0 132)
      `;
        };
      });

    function pathTween(path) {
      const length = path.node().getTotalLength(); // Get the length of the path
      const r = d3.interpolate(0, length); // Set up interpolation from 0 to the path length
      return function (t) {
        const point = path.node().getPointAtLength(r(t)); // Get the next point along the path
        d3.select(this) // Select the circle
          .attr("transform", `translate(${point.x}, ${point.y})`);
      };
    }
  }
  function reformatNumbers(value) {
    if (value > 1000000) {
      return String(Math.round(value / 1000000)) + "M";
    } else if (value > 1000) {
      return String(Math.round(value / 1000)) + "K";
    } else {
      return String(value);
    }
  }
</script>

<div class="speedDial">
  <div class="speedVar">
    <svg id="speedometer"></svg>
    <div id="percent">
      <h3>0%</h3>
    </div>
    <div class="number">
      <h3>{reformatNumbers($averageAge)}</h3>
    </div>

    <div style="text-align: center;transform:translateX(-38px);" class="label">
      Proportion of residents aged <br /> 15-45 within the travel zone
    </div>
  </div>
  <div class="speedVar1">
    <svg id="speedometer1"></svg>
    <div id="percent1"><h3>0%</h3></div>
    <div class="number">
      <h3>{reformatNumbers($averageCommute)}</h3>
    </div>
    <div style="transform:translateX(-40px);text-align: center;" class="label">
      Proportion of residents with<br /> a commute under 10km
    </div>
  </div>
  <div class="speedVar2">
    <svg id="speedometer2"></svg>
    <div id="percent2"><h3>0%</h3></div>
    <div class="number">
      <h3>{reformatNumbers($averageWalk)}</h3>
    </div>

    <div style="transform:translateX(-40px);text-align: center;" class="label">
      Proportion of residents walking or<br />
      cycling to work within the travel zone
    </div>
  </div>
  <!-- <div class="speedVar3">
    <svg id="speedometer3"></svg>
    <div id="percent3"><h3>0%</h3></div>
    <div class="number">
      <h3>{reformatNumbers(tp * $averageDeprivation)}</h3>
    </div>
    <div style="transform:translateX(35px);" class="label">% Deprevation</div>
  </div>-->
</div>

<style>
  #percent {
    position: absolute;
    top: 140px;
    z-index: 10000;
    left: 43%;
    font-size: 35px;
  }
  #percent1 {
    position: absolute;
    z-index: 10000;
    top: 140px;
    left: 43%;
    font-size: 35px;
  }
  #percent2 {
    position: absolute;
    top: 140px;
    left: 43%;
    font-size: 35px;
  }
  #percent3 {
    position: absolute;
    top: 140px;
    left: 43%;
    font-size: 35px;
  }
  .speedDial {
    scale: 0.9;
    transform: translate(-70px, 15px);
  }
  .label {
    position: absolute;
    top: 275px;
    left: 15%;
    width: 284px;
    font-size: 15px;
  }
  .speedVar {
    position: absolute;
    transform: translateY(-55px);
    scale: 0.88;
  }
  .speedVar1 {
    position: absolute;
    transform: translate(270px, -55px);
    scale: 0.88;
  }
  .speedVar2 {
    position: absolute;
    transform: translate(540px, -55px);
    scale: 0.88;
  }
  .speedVar3 {
    position: absolute;
    transform: translate(810px, -55px);
    scale: 0.88;
  }
  #speedometer {
    position: relative;
    width: 300px;
    height: 300px;
  }
  #speedometer1 {
    position: relative;
    width: 300px;
    height: 300px;
  }
  #speedometer2 {
    position: relative;
    width: 300px;
    height: 300px;
  }
  #speedometer3 {
    position: relative;
    width: 300px;
    height: 300px;
  }
  .number {
    position: absolute;
    top: 180px;
    text-align: center;
    left: 45%;
    font-size: 20px;
  }
</style>
